import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import PlatformLayout from "@/layouts/PlatformLayout";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Users, UserPlus, Mail, Building2, Loader2 } from "lucide-react";
import { API } from "@/constants";
import { useAuth } from "@/contexts/AuthContext";

const PlatformProfilesPage = () => {
  const { user } = useAuth();

  return (
    <PlatformLayout activeTab="profiles">
      <div className="p-6 max-w-4xl mx-auto" data-testid="platform-profiles">
        <h1 className="text-xl font-bold text-slate-900 mb-6">Team & Profiles</h1>

        <Card className="mb-6">
          <CardHeader>
            <CardTitle className="text-base flex items-center gap-2">
              <Building2 className="h-4 w-4 text-blue-600" /> Your Profile
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <p className="text-xs text-slate-500 mb-0.5">Name</p>
                <p className="text-sm font-medium">{user?.name || "—"}</p>
              </div>
              <div>
                <p className="text-xs text-slate-500 mb-0.5">Email</p>
                <p className="text-sm font-medium">{user?.email || "—"}</p>
              </div>
              <div>
                <p className="text-xs text-slate-500 mb-0.5">Role</p>
                <Badge className="capitalize">{user?.role || "user"}</Badge>
              </div>
              <div>
                <p className="text-xs text-slate-500 mb-0.5">Firm</p>
                <p className="text-sm font-medium">{user?.firm_name || "—"}</p>
              </div>
            </div>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <div className="flex items-center justify-between">
              <CardTitle className="text-base flex items-center gap-2">
                <Users className="h-4 w-4 text-emerald-600" /> Team Members
              </CardTitle>
              <Button size="sm" variant="outline">
                <UserPlus className="h-3.5 w-3.5 mr-1.5" /> Invite
              </Button>
            </div>
          </CardHeader>
          <CardContent>
            <div className="space-y-2">
              {[
                { name: "Admin User", email: "admin@trialeze.com", role: "admin" },
                { name: "Demo User", email: "demo@trialeze.com", role: "demo" },
                { name: "Company User", email: "company@trialeze.com", role: "company" },
              ].map((member, i) => (
                <div key={i} className="flex items-center justify-between p-3 rounded-lg bg-slate-50">
                  <div className="flex items-center gap-3">
                    <div className="w-8 h-8 rounded-full bg-blue-100 text-blue-600 flex items-center justify-center text-xs font-bold">
                      {member.name.charAt(0)}
                    </div>
                    <div>
                      <p className="text-sm font-medium">{member.name}</p>
                      <p className="text-xs text-slate-400">{member.email}</p>
                    </div>
                  </div>
                  <Badge variant="outline" className="capitalize text-xs">{member.role}</Badge>
                </div>
              ))}
            </div>
          </CardContent>
        </Card>
      </div>
    </PlatformLayout>
  );
};

export default PlatformProfilesPage;
